import React from "react"
import { view } from "react-easy-state"
import { isMobile } from "react-device-detect"
import { Select, Input, Row, Col, message } from "antd"

import Header from "components/common/layouts/Header"
import Footer from "components/common/layouts/Footer"
import ContentLoader from "components/common/ContentLoader"
// import CourseList from 'components/pages/students/courses/index/CourseList'
import SubjectList from "components/pages/students/subjects/index/SubjectList"

import globalStore from "store"
// import * as AuthHelper from "helpers/auth.helper"

import SubjectsService from "services/students/subjects.service"
import ContentLoadingFailed from "components/common/ContentLoadingFailed"
// import AskDoubt from "components/pages/students/AskDoubt"

const topbarFilterLeftColSpan = {
  xs: { span: 24 },
  sm: { span: 16 },
  md: { span: 18 },
}

const topbarFilterRightColSpan = {
  xs: { span: 24 },
  sm: { span: 8 },
  md: { span: 6 },
}

class SubjectsIndexPage extends React.Component {
  async componentDidMount() {
    const { courseId } = this.props.match.params

    const pageState = globalStore.ui.students.subjects.index
    await SubjectsService.index({ pageState, courseId })
  }

  renderPageContent() {
    const pageState = globalStore.ui.students.subjects.index
    const { course, subjects, papers, courseErrors, API_SUBJECTS_INDEX_STATUS } = pageState

    if (!API_SUBJECTS_INDEX_STATUS) return <ContentLoader />
    if (API_SUBJECTS_INDEX_STATUS === "pending") return <ContentLoader />
    if (API_SUBJECTS_INDEX_STATUS === "rejected") return <ContentLoadingFailed />

    if (courseErrors) {
      message.destroy()
      message.error(courseErrors)
      this.props.history.replace("/courses")
      return
    }

    return <SubjectList subjects={subjects} papers={papers} course={course} />
  }

  componentWillUnmount() {
    globalStore.ui.students.subjects.index = {}
  }

  render() {
    // const headerContent = (
    //   <React.Fragment>
    //     <div className="top-bar">
    //       <div>
    //         <Button type="link" onClick={() => this.props.history.push(`/courses`)}>
    //           <Icon type="arrow-left" />
    //         </Button>
    //         <Button style={{ padding: 0 }} type="link" onClick={() => this.props.history.push("/")}>
    //           <h1>Learner</h1>
    //         </Button>
    //       </div>
    //     </div>
    //     <div className="top-menu-wrapper">
    //       {!isMobile && (
    //         <React.Fragment>
    //           <Button type="link" onClick={() => this.props.history.push("/courses")}>
    //             Courses
    //           </Button>
    //           <Button type="link" onClick={() => this.props.history.push("/doubts")}>
    //             My doubts
    //           </Button>
    //           <Button type="link" onClick={() => this.props.history.push("/doubts/all")}>
    //             All doubts
    //           </Button>
    //           <Button type="link" onClick={() => this.props.history.push("/profile")}>
    //             Profile
    //           </Button>
    //           <AskDoubt
    //             buttonText="Ask a doubt"
    //             buttonType="link"
    //             buttonStyle={{
    //               position: "initial",
    //               display: "flex",
    //               justifyContent: "flex-end",
    //             }}
    //           />
    //           <Button type="link" onClick={() => AuthHelper.logout()}>
    //             Logout
    //           </Button>
    //         </React.Fragment>
    //       )}
    //       {/*
    //         <ul className="top-menu">
    //           <li><a href="/">My Courses</a></li>
    //           <li><a href="/">All Courses</a></li>
    //           <li><a href="/">Account</a></li>
    //         </ul>
    //       */}
    //     </div>
    //   </React.Fragment>
    // )

    const filterRow = (
      <div className="topbar-filter">
        <Row>
          <Col {...topbarFilterLeftColSpan} className="m-t-20">
            <div className="left-items">
              <div>
                <span>Category: </span>
                <Select defaultValue="all">
                  <Select.Option value="all">All</Select.Option>
                </Select>
              </div>
              <div>
                <span>Author: </span>
                <Select defaultValue="all">
                  <Select.Option value="all">All</Select.Option>
                </Select>
              </div>
            </div>
          </Col>
          <Col {...topbarFilterRightColSpan} className="m-t-20">
            <Input type="search" placeholder="Find a subject" />
          </Col>
        </Row>
      </div>
    )

    return (
      <div className={`page course-page ${isMobile ? "mobile" : ""}`}>
        <Header />
        <div className="page-content">
          {false && filterRow}
          {this.renderPageContent()}
        </div>
        <Footer />
      </div>
    )
  }
}

export default view(SubjectsIndexPage)
